import { withTolgee } from '@tolgee/i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import { I18nResource } from '@/i18n/i18n-supported-language';
import { i18nNamespaces } from '@/i18n/i18nNamespaces';
import { tolgee } from '@/i18n/tolgee';

export const defaultNS = 'common';

withTolgee(i18n, tolgee)
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: Object.values(I18nResource),
    fallbackLng: I18nResource.TH_TH,
    debug: false,
    ns: i18nNamespaces,
    defaultNS,
    // resources: undefined, // ! do not set. it is handled by tolgee `staticData`
    interpolation: {
      escapeValue: true,
    },
    returnNull: true,
    returnEmptyString: true,
    parseMissingKeyHandler: () => '',
    react: {
      bindI18n: 'languageChanged',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
      useSuspense: false,
    },
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lang',
    },
  });

export default i18n;
